<template>
	<div :class="[{ 'is-survey': isSurvey }, {'is-not-survey': !isSurvey}]">
		<div class="star">
			<template v-if="histogram">
				<div class="horizontal histogram">
					<div class="bin" v-for="choice in 5" v-if="selected(choice)" :key="choice">
						<div class="bar" :style="{ width: barHeight(choice) }">
							{{ displayHeight(choice) }}
						</div>
						<div class="text">
							{{ formatCount(displayValue(choice), 'time') }}
						</div>
						<label class="star">
							<i class="el-icon-star-on" v-for="star in (choice + 1)" :key="star"></i>
						</label>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="response"
					v-for="(r, index) in response" :key="index">
					<FlagRecord
						v-if="questionnaire[index] && questionnaire[index].problem && isSurvey && getUserType != 'observer'"
						:question="question"
						:event="questionnaire[index]"
						:patient="patient">
					</FlagRecord>
					<EditStar v-if="getUserType != 'observer' && cnstFrmCnntd === false" :question="question" :qDate="questionnaireDate(index)" :qNum="qNum" :oresponse="getOResponse(index)" :response="r" :event="questionnaire[index]" :patient="patient"></EditStar>
					<div :class="['date', {'no-answer-date': !r}]" v-if="response.length > 1">
						{{ questionnaireDate(index) }}
					</div>
					<div class="answer-wrapper">
						<StarPartial
							:response="r"
							:isSurvey="isSurvey"
							:question="question"
						></StarPartial>
					</div>
					<el-popover
						placement="left"
						width="400"
						trigger="click"
						:key="renderKey"
						v-if="isSurvey && getUserType === 'observer'"
						class="flag-modal">
						<button :disabled="comment.length != 0" :class="[showFlagDialog[index] ? 'flag-unresolved-button' : 'flag-button']" @click="addFlag(index)" slot="reference">
							<img :src="require(showFlagDialog[index] ? './icon/flag-unresolved.png' : './icon/flag.png')" class="flag-image"> Flag
							<span v-if="flagSavedText[index]" class="flag-saved-text">Flagged Successfully</span>
						</button>
						<div class="header">
							Add Comment
							<i class="el-icon-close" @click="closeModal(index)"></i>
						</div>
						<div class="add-comment">
							<el-input
								type="textarea"
								size="small"
								:rows="6"
								placeholder="Start typing..."
								:maxlength="150"
								v-model="comment">
							</el-input>
							<span class="char-left">
								{{ 150 - comment.length }} characters left
							</span>
						</div>
						<div class="dialog-footer">
							<LoadingButton type="primary" 
								@click="markFlagged(index)" style="width:105px; float: right;"
								:disabled="comment.length === 0"
								:loading="flagLoading">
								Done
							</LoadingButton>
							<el-button type="text" @click="closeModal(index)" class="cancel-button">Cancel</el-button>
						</div>
					</el-popover>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import QuestionResponse from '.'
import SelectValue from './mixin/select-value'
import StarPartial from './partialResponse/StarPartial'
import { mapActions, mapGetters } from 'vuex'
import LoadingButton from '@/module/component/LoadingButton.vue'

import Icons from './icon'

export default {
	extends: QuestionResponse,
	mixins: [ SelectValue ],

	data() {
		return {
			comment: '',
			renderKey: 0,
			flagLoading: false,
			flagSavedText: this.response.map(_ => false),
			showFlagDialog: this.response.map(_ => false)
		}
	},

	methods: {
		...mapActions('outcome', ['addFlagging', 'resolveFlagging']),
		getOResponse(index) {
			return this.oresponse[index]
		},
		addFlag(index) {
			if (this.comment.length)
				return
			this.showFlagDialog[index] = true
		},
		getUploader(uploaderId) {
            if(this.getUser && this.getUser.id === uploaderId)
                return this.getUser.name
            return null
        },
		/**
		 *  Flag object schema to send while marking/resolving flag
		 * 	{
		 * 		id: uuidv4(),
				problem_id: 'string', // event.problem id sent only during resolving
				question_id: this.question.id,
				comment: this.comment,
				// comment_resolution: 'string', //comment after marking resolved
				type: 'problem', // problem or resolution
				auth: this.getUserId
			}
		 */
		markFlagged(index) {
			this.comment = this.comment.trim()
			if (this.comment.length === 0)
				return
			this.flagLoading = true
			this.addFlagging({
				id: this.questionnaire[index].id,
				question_id: this.question.id,
				comment: this.comment,
				type: 'problem',
				auth: this.getUserId,
				patientId: this.patient.id
			})
			.then((response) => {
				this.flagLoading = false
				this.flagSavedText[index] = true
				this.closeModal(index)
				setTimeout(() => {
					this.flagSavedText[index] = false
					this.renderKey += 1
				}, 3000)
				response.problem_id = this.questionnaire[index].id
				response.modified_name = this.getUploader(response.modified_by)
				this.$emit('addFlagObj', response)
			})
		},
		closeModal(index) {
			this.showFlagDialog[index] = false
			this.comment = ''
			this.renderKey += 1
		}
	},

	computed: {
		...mapGetters(['getUserType']),
		...mapGetters('user', ['getUser']),
		...mapGetters('auth', ['getUserId']),
		...mapGetters('provider', [ 'allPatientsChosen', 'getProviderNameById'])
	},

	components: {
		StarPartial,
		LoadingButton
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";

.horizontal.histogram .bin > label.star {
	white-space: nowrap;
	width: 100px;
	left: -100px;
}
</style>
